var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utility/action/search-copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.124,19.13379 L18.89646,17.90625 L15.99936,15.00915 C17.0820232,13.7584886 17.6810601,12.1614861 17.688,10.50732 C17.6882973,7.68078993 15.9858262,5.13242673 13.3745098,4.05062317 C10.7631934,2.96881961 7.7573367,3.56663951 5.7586781,5.5652981 C3.76001951,7.5639567 3.16219961,10.5698134 4.24400317,13.1811298 C5.32580673,15.7924462 7.87416993,17.4949173 10.7007,17.49462 C12.35485,17.4876855 13.95184,16.8886652 15.2025,15.806025 L18.0996,18.703125 L19.32714,19.930665 C19.547191,20.150716 19.903964,20.150716 20.124015,19.930665 C20.344066,19.710614 20.344066,19.353841 20.124015,19.13379 L20.124,19.13379 Z M10.700685,16.369635 C8.32917496,16.3699323 6.19102758,14.9415586 5.28335265,12.7506259 C4.37567772,10.5596932 4.87724739,8.03771909 6.55415824,6.36080824 C8.23106909,4.68389739 10.7530432,4.18232772 12.9439759,5.09000265 C15.1349086,5.99767758 16.5632823,8.13582496 16.562985,10.507335 C16.5589354,13.743315 13.936665,16.3655854 10.700685,16.369635 L10.700685,16.369635 Z",
    id: "Color",
    fill: "#26294D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "search",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchQuiz);
export default __webpack_public_path__ + "static/media/SearchQuiz.a64658f8.svg";
export { ForwardRef as ReactComponent };